var render = function render(){var _vm=this,_c=_vm._self._c;return _c('reports-base',{attrs:{"exportable":"","reportsName":"invalidUsageProducts","reportsTitle":"Użycia zweryfikowane negatywnie","componentName":"InvalidUsageProducts"},on:{"onExport":_vm.onExport}})
}
var staticRenderFns = []

export { render, staticRenderFns }